import Reveal from '@/components/base/Reveal';
import { heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative bg-background-50 overflow-hidden">
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-primary-100/60 blur-3xl" aria-hidden="true"></div>
      <div className="absolute top-24 right-0 w-80 h-80 rounded-full bg-accent-100/60 blur-3xl" aria-hidden="true"></div>

      <div className="relative max-w-screen-xl mx-auto w-full px-4 md:px-6 pt-12 md:pt-20 pb-14 md:pb-20 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium">
              <i className="ri-fire-line text-base"></i>
              社区讨论氛围 · 每天都有新话题
            </span>
          </Reveal>

          <Reveal delay={80}>
            <h1 className="mt-5 font-heading font-black text-foreground-950 tracking-tight leading-[1.1] text-4xl md:text-6xl">
              黑料福利
              <span className="block mt-3 text-xl md:text-3xl font-bold text-primary-600">
                每日更新不断更 · 今日最新新料抢先看
              </span>
            </h1>
          </Reveal>

          <Reveal delay={150}>
            <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl">
              一个由网友一起维护的话题讨论社区。黑料福利每日汇总当天最热的讨论，
              <span className="text-foreground-800 font-medium">黑料福利最新</span>
              新料同步上线，黑料福利今日更新抢先看，来话题墙聊一聊你正在关注的那一条。
            </p>
          </Reveal>

          <Reveal delay={220}>
            <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:items-center">
              <a
                href="#latest"
                className="cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors"
              >
                <i className="ri-flashlight-line w-5 h-5 flex items-center justify-center"></i>
                查看今日最新新料
              </a>
              <a
                href="#topics"
                className="cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-100 text-foreground-900 text-sm md:text-base font-medium border border-background-300 hover:bg-background-200 transition-colors"
              >
                <i className="ri-chat-3-line w-5 h-5 flex items-center justify-center"></i>
                进入话题墙
              </a>
            </div>
          </Reveal>

          <Reveal delay={290}>
            <div className="mt-10 grid grid-cols-3 gap-4 md:gap-6 max-w-lg">
              {heroStats.map((stat) => (
                <div key={stat.label} className="flex flex-col">
                  <span className="font-heading font-black text-2xl md:text-3xl text-foreground-950">
                    {stat.value}
                    <span className="text-sm md:text-base font-bold text-foreground-500 ml-1">{stat.unit}</span>
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={160}>
            <div className="relative">
              <div className="relative w-full aspect-[4/5] rounded-lg overflow-hidden border border-background-200 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20glossy%20entertainment%20magazine%20covers%20with%20warm%20crimson%20and%20gold%20light%20beams%2C%20dramatic%20shadows%2C%20layered%20paper%20texture%2C%20premium%20magazine%20feel%2C%20soft%20dark%20background%2C%20no%20people%2C%20high%20detail&width=1000&height=1250&seq=hl-cover-hero&orientation=portrait"
                  alt="黑料福利每日话题封面"
                  title="黑料福利 每日更新 今日最新"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-bold">
                    <i className="ri-vip-crown-2-line"></i>
                    今日热榜 TOP1
                  </span>
                  <p className="mt-3 text-background-50 font-heading font-bold text-base md:text-lg leading-snug">
                    综艺剪辑争议时间线整理，讨论热度 98.6 万
                  </p>
                </div>
              </div>

              <div className="hidden sm:flex absolute -bottom-5 -left-5 items-center gap-3 bg-background-50 border border-background-200 rounded-lg px-4 py-3 animate-floaty">
                <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                  <i className="ri-group-line text-xl"></i>
                </span>
                <span className="flex flex-col leading-tight">
                  <span className="font-heading font-black text-lg text-foreground-950">876 人</span>
                  <span className="text-xs text-foreground-500">此刻正在讨论</span>
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}